import React from 'react';
import { getText } from '../../data/texts';

const Prima = ({ data }) => {

    const { prima, cuota } = data;

    const samePrima = prima === cuota;

    const DivCuota = () => <h2>$ {cuota}</h2>;

    return (
        <div>
            
            {samePrima ?
                    <DivCuota/>
                :
                <>
                    <DivCuota/>
                    <h2>Total a pagar $ {prima}</h2>
                </>
            }
            
        </div>
    );
}

export default Prima;
